import { webBuildNumber } from "@ninjacart/nc-nk-core";
import axios from 'axios';
import { Platform } from 'react-native';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { useAppPersistenceStore } from "../../store/useAppPersistenceStore";
import { getWorkflowV2URI } from "../paths";

export const CourseClient = axios.create({
    baseURL: getWorkflowV2URI(),
    timeout: 60000,
    headers: {
        Accept: 'application/json',
        'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
        'x-version-code': getVersion(),
        'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
        ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
    },
  });

  CourseClient.interceptors.request.use(async (config) => {
    config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage,
    config.headers['x-device-id'] = useAppPersistenceStore?.getState()?.deviceId ?? '';
    return Promise.resolve(config);
  });
  